import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSolarPanel: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSolarPanel"><Path d="M4.5 20.5H19.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M5.5 3.5H18.5L20.5 14.5H3.5L5.5 3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M12 3.75V14.25" stroke="currentColor" strokeLinecap="square"/><Path d="M19.25 9H4.75" stroke="currentColor" strokeLinecap="square"/><Path d="M12 14.5V20.25" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSolarPanel;
